import React from 'react';
import PropTypes from 'prop-types';

import { getFormatDateWithDaysAgo } from 'utilities/date';

import { getDisplayUserName } from '../utility';

const ProductQuestionsAndAnswersBestAnswerCard = ({
	text, user, dateCreated, recommendedProducts
}) => (
	<div className="ProductQuestionsAndAnswersCard__bestAnswer">
		<span className="ProductQuestionsAndAnswersCard__bestAnswerText">A:</span>
		<span dangerouslySetInnerHTML={{ __html: text }} />
		<div className="ProductQuestionsAndAnswersCard__recommendedProducts">
			{Array.isArray(recommendedProducts)
				&& recommendedProducts.map((recommendedProduct) => (
					<div
						className="ProductQuestionsAndAnswersCard__recommendedProductsImage"
						key={recommendedProduct.shortSku}
					>
						<a
							href={recommendedProduct.url}
							className="ProductQuestionsAndAnswersCard__recommendedProductsImageLink"
						>
							<img
								src={recommendedProduct.imageUrl}
								className="ProductQuestionsAndAnswersCard__recommendedProductsImageUrl"
								alt=""
								height="96"
								width="96"
							/>
							<span className="ProductQuestionsAndAnswersCard__recommendedProductsImageTitle">
								{recommendedProduct.title}
							</span>
						</a>
					</div>
				))}
		</div>
		<div className="ProductQuestionsAndAnswersCard__userInfoContainer">
			<span className="ProductQuestionsAndAnswersCard__userInfo">
				<span className="ProductQuestionsAndAnswersCard__bestAnswerName">
					{getDisplayUserName(user)}
				</span>
				{user !== null && user.badge !== null && (
					<span className="ProductQuestionsAndAnswersCard__badge">
						{user.badge.text}
					</span>
				)}
			</span>
			{dateCreated !== null && (
				<span className="ProductQuestionsAndAnswersCard__bestAnswerCreatedDate">
					{getFormatDateWithDaysAgo(dateCreated)}
				</span>
			)}
		</div>
	</div>
);

ProductQuestionsAndAnswersBestAnswerCard.propTypes = {
	text: PropTypes.string.isRequired,
	dateCreated: PropTypes.string.isRequired,
	user: PropTypes.shape({
		nickName: PropTypes.string,
		badge: PropTypes.shape({
			text: PropTypes.string
		})
	}),
	recommendedProducts: PropTypes.arrayOf(PropTypes.any)
};
export default ProductQuestionsAndAnswersBestAnswerCard;
